var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "button",
        {
          class: [
            "btn-single-toggle",
            _vm.isRouteDescription ? "is-active" : "",
          ],
          staticStyle: { border: "1px solid #dddddd" },
          on: {
            click: function ($event) {
              _vm.isRouteDescription = !_vm.isRouteDescription
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("place")])]
      ),
      _vm._v(" "),
      _c(
        "multiselect",
        {
          ref: "multiselect",
          attrs: {
            options: _vm.items,
            loading: _vm.isLoadingItems,
            "allow-empty": false,
            "custom-label": _vm.serviceLabel,
            placeholder: "Zusatzleistung auswählen",
            "track-by": "id",
            "select-label": "",
            "deselect-label": "Löschen",
            disabled: _vm.disabled,
          },
          on: {
            "search-change": _vm.searchOtherServiceTypes,
            open: _vm.onOpen,
            close: _vm.onClose,
          },
          model: {
            value: _vm.otherServiceTypeSelected,
            callback: function ($$v) {
              _vm.otherServiceTypeSelected = $$v
            },
            expression: "otherServiceTypeSelected",
          },
        },
        [
          _c("template", { slot: "noResult" }, [
            _vm._v("Keine passenden Leistungsträger"),
          ]),
          _vm._v(" "),
          _c("template", { slot: "afterList" }, [
            _vm.hasMore
              ? _c("li", { staticClass: "multiselect__element" }, [
                  _c(
                    "span",
                    {
                      staticClass: "multiselect__option",
                      staticStyle: {
                        "text-align": "left",
                        cursor: "pointer",
                        color: "#3273dc",
                      },
                      on: {
                        mousedown: function ($event) {
                          $event.preventDefault()
                        },
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.loadMore.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.isLoadingMore
                            ? "...lade weitere Leistungen..."
                            : "Mehr Leistungen laden"
                        )
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("span", { attrs: { slot: "caret" }, slot: "caret" }, [
            _c(
              "a",
              {
                staticClass: "multiselect-crud-link",
                attrs: {
                  href: "/other_service_types?add",
                  title: "Füge einen neuen Leistungsträger hinzu",
                  target: "_blank",
                },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("add")])]
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }